import { render } from "./About.vue?vue&type=template&id=def9657c"
const script = {}
script.render = render

export default script